import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CoursesService } from 'src/app/services/courses.service';

@Component({
  selector: 's18-scorecard',
  templateUrl: './scorecard.component.html',
  styleUrls: ['./scorecard.component.scss']
})
export class ScorecardComponent implements OnInit {

  requestingRevision : boolean = false;
  message : string ="";
  course_id : string;
  scorecard : any[];
  hole_nbr_front : number[] = [1,2,3,4,5,6,7,8,9];
  hole_nbr_back: number[] = [10,11,12,13,14,15,16,17,18];

  constructor(
    private dialog: MatDialog,
    private courseService: CoursesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.course_id = this.data.course_id;
  }

  
  close(){
    this.dialog.closeAll();
  }

  ngOnInit() {

  }

}
